import { polarToXY } from '@circle/shared';
import type { DayCtx, Fragment } from '../types';
import { n, svgEl } from '../../core/svg';
import { metricsAt, W } from './metrics';

/**
 * One tick per day, pointing inward from the ring. Weekends are shorter and
 * dimmer; the first of the month gets a full-gutter tick. Sized to the ring it
 * is on, so a small circle's ticks stay in proportion to it rather than
 * swallowing it. Which days get a tick at all is the scene's call — below about
 * half the root radius it thins them out.
 */
export const dayFragment: Fragment<DayCtx> = (ctx, state) => {
  const M = metricsAt(ctx.radius);
  const first = ctx.day === 1;
  const inner = first ? M.monthTick : ctx.isWeekend ? M.weekendTick : M.dayTick;
  const outer = state.hover || state.selected ? M.ring + 10 : M.ring;

  const a = polarToXY(ctx.angle, inner);
  const b = polarToXY(ctx.angle, outer);

  const stroke = state.hover || state.selected
    ? 'var(--day-hover)'
    : ctx.isWeekend
      ? 'var(--day-weekend)'
      : 'var(--day)';

  const g = svgEl('g', { 'data-frag': 'day' });
  // Invisible fat stroke so a 1px tick is still clickable.
  g.append(
    svgEl('line', {
      x1: n(a.x),
      y1: n(a.y),
      x2: n(b.x),
      y2: n(b.y),
      stroke: 'transparent',
      'stroke-width': 6,
      'vector-effect': 'non-scaling-stroke',
      'pointer-events': 'stroke',
    }),
  );
  g.append(
    svgEl('line', {
      x1: n(a.x),
      y1: n(a.y),
      x2: n(b.x),
      y2: n(b.y),
      stroke,
      'stroke-width': first ? W.monthBoundary : W.day,
      'stroke-linecap': 'round',
      'vector-effect': 'non-scaling-stroke',
      opacity: ctx.isWeekend && !state.hover ? 0.75 : 1,
      'pointer-events': 'stroke',
    }),
  );
  return g;
};
